import { useEffect, useState } from "react";

import { usePostSearchStatus } from "api/usePostSearchStatus";
import { SearchStatusSingleFileRequest } from "generated-types";
import { DocumentData } from "util/interfaces/DocumentData";

type Props = { documents: DocumentData[] | undefined };
export const usePollingSearchStatus = ({ documents }: Props) => {
  const [payload, setPayload] = useState<SearchStatusSingleFileRequest[] | null>(null);

  usePostSearchStatus(payload, !!payload && payload.length > 0);

  useEffect(() => {
    if (!documents) return;

    const isNeedRefetch = documents?.some((file) => file.indexing_status === "IN_PROGRESS");

    if (isNeedRefetch) {
      const filesToSearch = documents.filter((file) => file.indexing_status === "IN_PROGRESS");
      const payload = filesToSearch.map(({ file_name }) => ({ file_name }));
      setPayload(payload);
    } else {
      setPayload(null);
    }
  }, [documents]);
};
